import { Empty, Icon } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useProgramsInfiniteQuery } from 'features/programs/queries';

type P = {
  getPathToProgramDetail: (id: string) => string;
  organizationId: string;
};

const OrganizationsProgramsList = ({ getPathToProgramDetail, organizationId }: P) => {
  const {
    data: allProgramsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useProgramsInfiniteQuery({
    filter: { organizationId },
    pagination: { pageSize: 12 },
  });

  const allPrograms = allProgramsData?.pages.flat().flatMap((programsPaginated) => programsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no programs to display here',
            title: 'No programs',
          }}
          image={<Icon icon="mortarboard-line" />}
        />
      }
      entities={allPrograms?.map((program) => ({
        data: program,
        type: 'Program',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToProgramDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll}
    />
  );
};

export default OrganizationsProgramsList;
